import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 10px;
  height: auto;
  overflow: auto;
`;

export const Col = styled.div`
  display: flex;
  flex: 1;
  padding: 10px;
  align-items: center;
  text-align: center;
`;

export const Row = styled.div`
  display: flex;
  min-height: 50px;
`;

export const ChartsRow = styled.div`
  padding: 10px;
  display: block;
  width: 100%;
  height: auto;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  margin-bottom: 10px;
`;

export const Scroller = styled.div`
  display: block;
`;

export const Item = styled.div`
  height: 163px;
  width: 200px;
  display: inline-block;
`;

export const TextContainer = styled.div`
  width: 200px;
  white-space: 'nowrap';
`;

export const ChartContainer = styled.div`
  width: 200px;
  height: 200px;
`;
